import { render, staticRenderFns } from "./PointIcons.vue?vue&type=template&id=815f15e6&"
import script from "./PointIcons.vue?vue&type=script&lang=js&"
export * from "./PointIcons.vue?vue&type=script&lang=js&"
import style0 from "./PointIcons.vue?vue&type=style&index=0&id=815f15e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports